import { apiClient } from '@services/api-client'
import { BACK_OFFICE_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import type { TaskCatalogItem } from '@features/cron/types'

export const taskCatalogQueryKey = ['scheduled-tasks', 'catalog']

export function useTaskCatalog() {
  async function getCatalog(): Promise<TaskCatalogItem[]> {
    const res = await apiClient.get<TaskCatalogItem[]>(
      BACK_OFFICE_PREFIX + 'scheduled-tasks/catalog'
    )
    return res.data
  }

  return useQuery({
    queryFn: getCatalog,
    queryKey: taskCatalogQueryKey
  })
}
